export { default as TabsView } from './view'
export type { Props as TabsViewProps } from './view'
